import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { translate } from "../translations";

function Contact() {
  const { language } = useLanguage();

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">
            {translate("contactBadge", language)}
          </span>
          <h2 className="section-title">
            <span className="contact-title-y">Let's Build</span>{" "}
            <span className="contact-title-gala">Something Amazing</span>{" "}
            <span className="contact-title-ad">Together</span>
          </h2>
          <p className="section-description">
            {translate("contactDescription", language)}
          </p>
        </div>
        <div className="contact-content">
          <div className="contact-cards">
            <a
              href="mailto:contact@ygalaad.com"
              className="contact-card"
              aria-label={translate("email", language)}
            >
              <span className="contact-card-icon" aria-hidden>📧</span>
              <div className="contact-card-body">
                <h3 className="contact-card-title">{translate("email", language)}</h3>
                <span className="contact-card-label">contact@ygalaad.com</span>
              </div>
            </a>
            <a
              href={`/${language}/support`}
              className="contact-card"
              aria-label={translate("support", language)}
            >
              <span className="contact-card-icon" aria-hidden>💬</span>
              <div className="contact-card-body">
                <h3 className="contact-card-title">{translate("support", language)}</h3>
                <span className="contact-card-label">{translate("getSupport", language)}</span>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/ygalaad"
              target="_blank"
              rel="noreferrer"
              className="contact-card"
              aria-label={translate("linkedin", language)}
            >
              <span className="contact-card-icon" aria-hidden>🔗</span>
              <div className="contact-card-body">
                <h3 className="contact-card-title">{translate("linkedin", language)}</h3>
                <span className="contact-card-label">{translate("followUs", language)}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
